<template>
  <div grey-back full-height>

    <v-toolbar flat fixed>
        <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

        <v-toolbar-title class="white--text">
          Ledger Reports
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="updateroute">
          <v-icon>more_vert</v-icon>
        </v-btn>
    </v-toolbar>


    <v-form class="form-element hasToolbar grey-back" id="form">

      <v-layout wrap padding-top-ten white-background>

          {{testdata}}

        <v-flex xs12 sm12 md12 form-item @click="fn_openAccountLedger">
           <v-text-field  
              readonly
              v-model="accountLedgerName" 
              label="Select Ledger"
              :onUpdate="fn_updateAccountLedger" 
              placeholder=" " 
              append-icon="arrow_drop_down"
              ref="ref_accountLedger"
              v-validate="'required'" 
              data-vv-name="account ledger" 
              :error-messages="errors.collect('account ledger')"
              required>
           </v-text-field>

           
        </v-flex>

        <v-layout row wrap>
          <v-flex xs6 sm6 md6 form-item>
            <v-text-field type="date" label="Start Date" placeholder=" " v-model="startDate"></v-text-field>
          </v-flex>

          <v-flex xs6 sm6 md6 form-item>
            <v-text-field type="date" label="End Date" placeholder=" " v-model="endDate"></v-text-field>
          </v-flex>
        </v-layout>

        
              <v-btn color="success" block @click="fn_checkValidations(accountLedgerId)">Get Report</v-btn>
      </v-layout>
    </v-form>


    <div v-if="data.ledgerItems.length">
        <v-data-table :headers="headers" :items="data.ledgerItems" hide-actions class="elevation-1">
   
          <template slot="items" slot-scope="props">
            <tr @click="fn_getLedgerDetails(props.item.transactionId)" 
              v-if="getTransactionType(props.item.transactionListId) != 'Opening Ledger'">

              <td>{{props.item.prefix}}/{{props.item.transactionNumber}}{{props.item.suffix ? '/'+props.item.suffix : ''}}</td>
              <td>{{props.item.transactionDate | moment("DD-MMM-YYYY")}}</td>
              <td>{{props.item.accountName}}</td>
              <td>{{getTransactionType(props.item.transactionListId)}}</td>
              <td class="align-right">{{props.item.amountType == 1 ? props.item.amount : 0}}</td>
              <td class="align-right">{{props.item.amountType == 0 ? props.item.amount : 0}}</td>
              <td class="align-right">{{props.item.balance}}</td>
              <td>{{props.item.actualBalance < 0 ? 'To Pay' : props.item.actualBalance > 0 ? 'To Receive' : '-'}}</td>
              <td>{{props.item.notes}}</td>

            </tr>
          </template>
        </v-data-table>

    </div>

     <v-bottom-sheet v-model="details">


        <div white-background>
          <!-- <v-subheader white-background>Details
            <v-spacer></v-spacer>
            <v-btn @click="details=false" icon><v-icon>close</v-icon></v-btn>
          </v-subheader> -->

          <v-divider></v-divider>

          <v-data-table :headers="detailHeaders" :items="data.ledgerDetails" hide-actions class="elevation-1">
     
            <template slot="items" slot-scope="props">
              <tr v-if="props.item.amountType!=null">
                <td>{{props.item.accountName}}</td>
                <td class="align-right">{{props.item.amountType == 1 ? props.item.amount : 0}}</td>
                <td class="align-right">{{props.item.amountType == 0 ? props.item.amount : 0}}</td>
              </tr>

              <tr class="bold" v-else>
                <td>Total</td>
                <td class="align-right">{{props.item.debitTotal}}</td>
                <td class="align-right">{{props.item.creditTotal}}</td>
              </tr>
            </template>
            
          </v-data-table>
          
        </div>
    </v-bottom-sheet>

  </div>
</template>

<script>
const dialogjs =  require('../masters/forms/dialog').dialogjs;

const transactionForms = require('../../config.js').configs.transactionForms;

let date_obj = new Date();

let customDate = date_obj.getFullYear() + "-" + ("0" + (date_obj.getMonth()+1)).slice(-2) + "-" + ("0" + date_obj.getDate()).slice(-2);

// console.log(customDate);

  export default{
    props:['settings'],
    data(){
      return{
        accountLedgerId:null,
        accountLedgerName:null,
        dialogStorageId:null,
        backButtonPress: false,
        startDate:customDate,
        endDate:customDate,
        formId:null,

        data: {"ledgerItems":[], "ledgerDetails":[]},

        // totals:[],

        headers: [
          {text: '#Ref', value: 'Ref', sortable:false},
          { text: 'Date', value: 'Date', sortable:false },
          { text: 'Party', value: 'Party', sortable:false },
          { text: 'VType', value: 'VType', sortable:false },
          { text: 'Debit', value: 'Debit', align: 'right', sortable:false },
          { text: 'Credit', value: 'Credit', align: 'right', sortable:false },
          { text: 'Balance', value: 'Balance', sortable:false },
          { text: '', value: '', sortable:false },
          { text: 'Notes', value: 'Notes', sortable:false },
        ],

        detailHeaders: [
          { text: 'Party', value: 'Party', sortable:false },
          { text: 'Debit', value: 'Debit', align: 'right', sortable:false },
          { text: 'Credit', value: 'Credit', align: 'right', sortable:false },
        ],

        details: false,
        testdata:null,
        nextdata:null

      }
    },
    methods:{

        updateroute: function(){
            this.testdata = "update";
            this.$router.push("/ledgerreport2");
        },

      getTransactionType: function (listId) {
        for(let i in transactionForms){
          if(transactionForms[i].id == listId){
            return transactionForms[i].title;
          }
        }
      },

      fn_openAccountLedger: function () {
        this.fn_openAccountLedgerDialog('android', 'AccountLedger', 'ref_accountLedger')
      },

      fn_openAccountLedgerDialog: function (platform, name, ref) {

        var tagId = this.guid();

        var dialogObj = {};
        dialogObj.tagId = tagId;
        dialogObj.formId = this.formId;
        dialogObj.name = name;
        dialogObj.ref = ref;
        //dialogObj.data = null;
        dialogObj.platform = platform;


        var self = this;

        var viewDialogObject = {};
        viewDialogObject.ToolbarTitle = "Select Account Ledger";
        viewDialogObject.TopMenu = null;
        viewDialogObject.isBottomMenu = false;

        var paramObject = {};
        paramObject.defaultValue = {"id":null, "name":null};

        if(this.accountLedgerId && this.accountLedgerName){
          paramObject.defaultValue = {"id":this.accountLedgerId, "name":this.accountLedgerName};
        }

        var self = this;
        dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);
      },

      fn_updateAccountLedger: function (selectedValueId, selectedValueName, isRemoved) {
        let self = this;
        if(!isRemoved){
          if(selectedValueId && this.accountLedgerId != selectedValueId){
            this.accountLedgerId = selectedValueId;
            this.accountLedgerName = selectedValueName;
          }
        }
        else{
          this.accountLedgerId = null;
          this.accountLedgerName = null;
        }

      },

      fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
        this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
      },

      fn_closeDialog: function (tagId) {
        dialogjs.fn_checkAndCloseOpenDialogs(this);
      },


      fn_showWebView: function () {
        var viewObject = {};
        viewObject.isBottomMenu = false;

        var tagId = null;
        var self = this;
        this.showWebView(tagId, viewObject, 
          {
            onSuccess: function(response){
                  console.log(response);
                }, 
                onError: function(error){
                  console.log(error);
                }, 
                // onChange: null,
                onMenuItemClick: function (tagId, menuId, menuAction) {
              self.fn_menuItemClick(tagId, menuId, menuAction)
            }
          }
        );
      },

      fn_goBack: function(){
        this.backButtonPress = true;
        this.$router.go(-1);
      },

      fn_checkValidations: function(itemId){
        var self = this;
          this.$validator.validateAll().then((result) => {
              if (result) {
                this.fn_getReport(itemId);
              }
          });
      },

      fn_getReport: function (itemId) {
        let filterObject = {};
        filterObject.startDate = this.$moment(this.startDate).startOf('day');
        filterObject.endDate = this.$moment(this.endDate).endOf('day');

        let self = this;
        this.getReportData('LedgerReport', itemId, filterObject, 
          {
            onSuccess: function(response){
              console.log(response);
              self.data = JSON.parse(response);

              let balanceObject = {};
              balanceObject.accountName = 'Opening Balance';
              balanceObject.amount = Number(self.data.currentBalance);
              balanceObject.amountType = self.data.currentBalance > 0 ? 1 : 0;

              self.data.ledgerItems.splice(0, 0, balanceObject);

              let balance = 0;

              self.data.ledgerItems.forEach(function (item) {
                balance += item.amount;
                item.actualBalance = balance;
                console.log(item.actualBalance);
                item.balance = Math.abs(balance).toFixed(2);
                console.log(item.balance);
                item.amount = Math.abs(item.amount).toFixed(2);
              });

              console.log(JSON.stringify(self.data.ledgerItems));
            }, 
            onError: function(error){
              console.log(error);
            }
          }
        );
      },

      fn_getLedgerDetails: function(itemId){
        if(!itemId){
          return;
        }

        var self = this;

        this.getData('LedgerReportDetails', itemId, 
          {
            onSuccess: function(response){
              console.log(response);
              self.data.ledgerDetails = JSON.parse(response);
              self.data.ledgerDetails.sort(function (a, b) {
                return b.amountType - a.amountType;
              });

              let debitTotal = 0;
              let creditTotal = 0;

              self.data.ledgerDetails.forEach(function (item) {
                item.amountType == 1 ? debitTotal += item.amount : creditTotal += item.amount;
                item.amount = Math.abs(item.amount).toFixed(2);
              });

              let totalObj = {};
              totalObj.debitTotal = Math.abs(debitTotal).toFixed(2);
              totalObj.creditTotal = Math.abs(creditTotal).toFixed(2);

              // self.totals = [];
              // self.totals.push(totalObj);

              self.data.ledgerDetails.push(totalObj);

              self.details = true;
            }, 
            onError: function(error){
                console.log(error);
            }
          }
        );
      },
    },
    mounted: function(){

        // alert('mounted');

      var self = this;

      this.formId = this.guid();

      this.dialogStorageId = 'dialog_'+this.formId;

      window.js_globals.fn_onBackPress = this.fn_goBack;
      window.js_globals.fn_closeClick = this.fn_closeDialog;

      this.fn_showWebView();

    },
    beforeRouteUpdate (to, from, next) {
        // alert('update')
        this.testdata = to.params.ledgerreport;
        next()
    },
    beforeRouteEnter (to, from, next) {
        // alert('Enter')
        next()
    },
    beforeRouteLeave (to, from, next) {
      if(this.details){
        this.details = false;
        next(false);
      }
      else{
        var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
        if(dialogData && dialogData.length){
          if(this.backButtonPress){
            dialogjs.fn_checkAndCloseOpenDialogs(this);
            this.backButtonPress = false;
            next(false);
          }
          else{
            next(true);
          }
        }
        else{
          this.backButtonPress ? localStorage.removeItem(this.draftStorageId) : '';
          next();
        }
      }
      
    }
  }

</script>

<style>
  .align-right{
    text-align:right;
  }
  tr.bold td{
    font-weight:500 !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/settings/ledgerreport.vue